var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ss__avatar__wrapper"},[_c('img',{ref:"img",staticClass:"ss__avatar",attrs:{"src":_vm.src || _vm.placeholder},on:{"error":_vm.onError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }